import { MouseEvent, ReactNode } from 'react';
import { SortFilterType } from './server';

export enum FETCH_METHODS {
  GET = 'GET',
  PATCH = 'PATCH',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

export type ProviderProps = {
  children: ReactNode;
};

export type MetaType = {
  title?: string;
  description?: string;
  keywords?: string;
  robots?: string;
  canonical?: string;
  h1?: string;
  text?: string;
  picture?: string;

  [key: string]: string | undefined;
};

export enum Sizes {
  Big = 'big',
  Small = 'small',
}

export enum Variants {
  Outline = 'outline',
  Filled = 'filled',
  Ghost = 'ghost',
}

export enum Palettes {
  Primary = 'primary',
  Secondary = 'secondary',
}

export type TabOption = {
  label: string;
  value: string;
  icon?: string;
  activeIcon?: string;
  accentColor?: string;
};

export type IconType = {
  className?: string;
  size?: number;
  color?: string;
  onClick?: (event: MouseEvent<SVGSVGElement>) => void;
};

export type PageContentType = any;

export enum PageViewType {
  Grid = 'grid',
  List = 'list',
}

export type PathSegment = {
  isProduct: boolean;
  data: PageContentType;
};

export enum FetchUrlType {
  Catalog = 'catalog',
  Search = 'search',
  Promotions = 'promotions',
  Brands = 'brands',
  Favourites = 'favourites',
}

export type UrlParams = {
  pathname?: string;
  sectionId?: string;
  sort: SortFilterType;
  inStock: InStockFilterValues;
  filtersQuery: string;
  itemsPerPage: number;
  code?: string;
};

export enum InStockFilterValues {
  InStock = 'Y',
  OutOfStock = 'N',
}

export type PlacementType =
  | 'top'
  | 'bottom'
  | 'left'
  | 'right'
  | 'topLeft'
  | 'topRight'
  | 'bottomLeft'
  | 'bottomRight';

export type TokensType = {
  accessToken?: string;
  refreshToken?: string;
};

export type ServicesRegistrationFields = {
  name: string;
  surname: string;
  email: string;
  ads: boolean;
  personalData: boolean;
};

export type RegistrationFormInputs = {
  name: string;
  surname: string;
  email: string;
  ads: boolean;
  personalData: boolean;
};
